import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Seo from "../Components/Seo";
import { useAuth } from "../Utility/AuthContext";

export default function Intro() {
  const { user } = useAuth();
  return (
    <>
      <Seo />
      <section className="hero">
        <div className="hero-copy">
          <span className="eyebrow">For the stories only you can tell</span>
          <Typography variant="h1" component="h1">
            One story.
            <br />A thousand
            <br />
            <em>possibilities.</em>
          </Typography>
          <p>
            Give your readers a world to get lost in—and the freedom to find
            their own way. Write, share, and play choose your own adventure
            stories.
          </p>
          <div className="hero-actions">
            <Button
              component={Link}
              to={user ? "/create" : "/register"}
              variant="contained"
              size="large"
              endIcon={<ArrowForwardIcon />}
            >
              Write your first chapter
            </Button>
            <Button
              component={Link}
              to="/dashboard"
              variant="outlined"
              size="large"
            >
              Explore the library
            </Button>
          </div>
          <span className="hero-note">Free to create. Yours to imagine.</span>
        </div>
        <div
          className="story-art"
          aria-label="Example of a branching adventure story"
        >
          <div className="art-card">
            <span className="eyebrow">A glimpse of your next adventure</span>
            <Typography sx={{ fontSize: 38 }} aria-hidden="true">
              ✧
            </Typography>
            <h2>The forest remembers.</h2>
            <p>
              At the edge of the clearing, the path splits in two. A lantern
              flickers between the trees. Somewhere beyond it, someone is
              waiting.
            </p>
            <div className="art-choice selected">
              Follow the lantern <span>↗</span>
            </div>
            <div className="art-choice">
              Take the forgotten path <span>↗</span>
            </div>
          </div>
          <div className="art-caption">Every choice opens a new door.</div>
        </div>
      </section>
      <section className="feature-strip" aria-label="How it works">
        {[
          [
            "01",
            "Build a world",
            "Start with an idea. Turn it into branching scenes and meaningful choices with a visual editor or a familiar spreadsheet.",
          ],
          [
            "02",
            "Make every choice matter",
            "Give readers items, unlock hidden paths, and write endings worth finding. Your imagination sets the rules.",
          ],
          [
            "03",
            "Let the adventure begin",
            "Share your story with curious readers. Explore other worlds, save your place, and discover a different ending.",
          ],
        ].map(([number, title, text]) => (
          <article className="feature" key={number}>
            <span className="feature-number">{number} /</span>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </section>
    </>
  );
}
